// extracted by mini-css-extract-plugin
export default {"fullWidth":"Cn-z","image":"Dn-z","lazyLoadPicture":"En-z","lazyLoadSpinner":"Fn-z","lazyLoadSpin":"Gn-z","lazyLoadImage":"Hn-z","hasStyledAspectRatio":"In-z"};